$(document).ready(function () {
    $('.marquee-left').marquee({
      direction: 'left',
      duration: 40000,
      delayBeforeStart: 0,
      duplicated: true,
      gap: 0,
      startVisible: true
    });

  $(document).ready(function () {  
  	// categories thumbnail 
    var swiper = new Swiper(".cat-list", {
      slidesPerView: 1.5,
      spaceBetween: 20,
      scrollbar: {
        draggable: true,
        el: ".swiper-scrollbar"
      }
    });
  });  

   $('.marquee-left-text').marquee({
      direction: 'left',
      duration: 40000,
      delayBeforeStart: 0,
      duplicated: true,
      gap: 0,
      startVisible: true
    });

    $(".products-slider-mobile").slick({
    dots: false,
    arrows: true,
    centerMode: true,
    slidesToShow: 1.5,
    infinite: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 1
  });

  function footerAccordion() {

    if ($(window).width() <= 500) {

      // Hide all accordions first
      $('.footer-block--menu .footer-block__details-content').hide();

      // Open first accordion by default
      $('.footer-block--menu').first().find('.footer-block__details-content').show();
      $('.footer-block--menu').first().addClass('active');

      // Click event
      $('.footer-block__heading').off('click').on('click', function () {

        const parent = $(this).closest('.footer-block--menu');
        const content = parent.find('.footer-block__details-content');

        // If already open -> close it
        if (parent.hasClass('active')) {
          parent.removeClass('active');
          content.slideUp();
        } else {

          // Close all
          $('.footer-block--menu').removeClass('active');
          $('.footer-block__details-content').slideUp();

          // Open current
          parent.addClass('active');
          content.slideDown();
        }

      });

    } else {

      // Desktop reset
      $('.footer-block__details-content').show();
      $('.footer-block--menu').removeClass('active');

    }

  }

  footerAccordion();

  $(window).on('resize', function () {
    footerAccordion();
  });


  $(document).on('click', '.description_tab .tab_drawer_heading', function () {
    var target = $(this).attr('rel'); // tab-description / tab-review

    $('.tab_drawer_heading').removeClass('d_active');
    $(this).addClass('d_active');

    $('.description_tab > div[id^="tab-"]').removeClass('active').hide();

    $('#' + target).addClass('active').show();
  });
  
});

